import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import CityDetails from "../components/city-details";
import SocialMediaFixed from "../components/socialmedia-fixed";


const CityDetailsPage = () => {

    return (
        <>
            <Helmet>
                <title>MP Holidays - Best DMC for Madhya Pradesh Tours & Travel Packages</title>
                <meta name="description" content="MP Holidays is a leading Destination Management Company (DMC) for Madhya Pradesh, offering customized heritage, wildlife, pilgrimage, and adventure tour packages. Explore the heart of India with expert planning and seamless travel services." />
                <meta name="keywords" content="MP Holidays, Madhya Pradesh DMC, Madhya Pradesh tourism, best tour operator MP, heritage tours MP, wildlife tours MP, pilgrimage tours MP, adventure tourism MP, customized tour packages MP, best travel agency MP, Madhya Pradesh travel expert" />
                <link rel="canonical" href="https://mpholidays.online/" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "TravelAgency",
                        "name": "MP Holidays - Best DMC for Madhya Pradesh Tours",
                        "telephone": "+91 9319184060",
                        "url": "https://mpholidays.online",
                        "description": "MP Holidays is a premier Destination Management Company specializing in Madhya Pradesh tourism, offering customized heritage, wildlife, pilgrimage, and adventure tour packages.",
                        "areaServed": "Madhya Pradesh, India",
                        "serviceType": "Tour Packages, Travel Planning, Hotel Bookings, Local Transport, Guided Tours"
                    })}
                </script>
            </Helmet>

            <TopBanner />
            <Navbar />
            <CityDetails />
            <Footer />
            <SocialMediaFixed/>
           
        </>
    );
};

export default CityDetailsPage;
